import { imageDimensions } from '@eliadmin/core/src/utils/image-dimensions';

// Dimensions read from these exact tenant SVG assets. Unknown/replaced logos
// retain their existing behavior unless the API supplies explicit dimensions.
const knownLogos = new Set([
  'https://api.fytofarm.sk/files/fytofarm-logo-7xyjFT2apJ7y3Zr5gpu2GzVCvInxc9OFUBDQ2fN8.svg',
  'https://api.fytofarm.sk/files/fytofarm-white-logo-7Vw7Nejb5OJkmF2Fxxz8PDJPN2Ua4brOmJSrU6EJ.svg',
  'https://api.fytofarm.com/files/fytofarm-logo-7xyjFT2apJ7y3Zr5gpu2GzVCvInxc9OFUBDQ2fN8.svg',
  'https://api.fytofarm.com/files/fytofarm-white-logo-7Vw7Nejb5OJkmF2Fxxz8PDJPN2Ua4brOmJSrU6EJ.svg',
]);

export function fytofarmLogoDimensions(image: unknown) {
  const explicit = imageDimensions(image);
  if (explicit) return explicit;
  if (!image || typeof image !== 'object' || !('url' in image) || typeof image.url !== 'string') {
    return undefined;
  }
  const assetUrl = image.url.split(/[?#]/)[0];
  return knownLogos.has(assetUrl) ? { width: 291, height: 32 } : undefined;
}
